import React, { cloneElement, useCallback } from 'react';
import { BusinessCollection } from '../../data-layer/business/constants';
import { BusinessModel } from '../../data-layer/business/types';
import { BusinessListItem, BusinessListItemSkeleton } from '../../ui/business/BusinessListItem';
import { Box } from '../../ui/layout/Box';
import { DataTestId } from '../../ui/layout/DataTestIdWrapper';
import { Flex } from '../../ui/layout/Flex';
import { Stack } from '../../ui/layout/Stack';
import { Typography } from '../../ui/typography/Typography';
import { ymTrackSearchGoToBusiness } from '../../utils/metrika';
import { useBusinessCallbacks } from '../business/useBusinessCallbacks';
import { useBusinessCollection } from '../business/useBusinessCollection';
import { useCurrentUser } from '../users/useCurrentUser';

export const SearchBusiness = () => {
    const collection = useBusinessCollection({
        namespace: BusinessCollection.SEARCH,
    });
    const businessCallbacks = useBusinessCallbacks();
    const currentUser = useCurrentUser();
    const onBusinessClick = useCallback(() => {
        ymTrackSearchGoToBusiness({
            page: 'Поиск',
            userLogin: currentUser?.login,
            businessId: currentUser?.profile?.publicId,
        });
    }, [currentUser]);

    const getBusiness = (business: BusinessModel) =>
        business ? (
            <BusinessListItem
                business={business}
                onClick={onBusinessClick}
                {...businessCallbacks}
            />
        ) : (
            <BusinessListItemSkeleton />
        );

    return collection.isLoading || collection.businesses.length > 0 ? (
        <Box
            height="100%"
            overflowY="auto"
            dataTestId={DataTestId.SEARCH_PROFILES_SCROLL_CONTAINER}
        >
            <Stack
                width="100%"
                maxWidth="100%"
                count={collection.businesses.length}
                renderItem={(index) =>
                    cloneElement(getBusiness(collection.businesses[index]), { key: index })
                }
            />
        </Box>
    ) : (
        <Flex
            px={3}
            alignItems="flex-start"
            justifyContent="center"
            flexGrow={1}
            spacing={1}
            dataTestId={DataTestId.SEARCH_NOT_FOUND}
        >
            <Typography variant="title2" weight="bold">
                Ничего не найдено
            </Typography>
            <Typography>Попробуйте другой запрос</Typography>
        </Flex>
    );
};
